// pages/NotFound.jsx
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

const NotFound = () => {
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          window.location.href = '/';
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="notfound-container">
      <div className="notfound-content">
        <div className="error-code">
          <span>4</span>
          <div className="zero-wrapper">
            <div className="zero"></div>
          </div>
          <span>4</span>
        </div>
        
        <h1>Page Not Found</h1>
        <p>Oops! The page you're looking for seems to have vanished into thin air.</p>
        
        <div className="action-buttons">
          <Link to="/" className="btn-primary">
            ← Back to Home
          </Link>
          <Link to="/contact" className="btn-secondary">
            Report Issue
          </Link>
        </div>
        
        <p className="auto-redirect">
          Redirecting to homepage in {countdown} seconds...
        </p>
      </div>

      <style jsx>{`
        .notfound-container {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        }

        .notfound-content {
          text-align: center;
          padding: 3rem;
          background: rgba(255, 255, 255, 0.95);
          border-radius: 20px;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
          max-width: 550px;
          margin: 20px;
          animation: slideUp 0.5s ease-out;
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .error-code {
          font-size: 120px;
          font-weight: bold;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 20px;
          margin-bottom: 20px;
          color: #764ba2;
        }

        .zero-wrapper {
          position: relative;
          width: 100px;
          height: 100px;
        }

        .zero {
          position: absolute;
          width: 80px;
          height: 80px;
          border: 12px solid #764ba2;
          border-radius: 50%;
          top: 10px;
          left: 10px;
          animation: spin 3s linear infinite;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        h1 {
          font-size: 32px;
          color: #333;
          margin: 20px 0 10px;
        }

        p {
          color: #666;
          line-height: 1.6;
          margin-bottom: 30px;
        }

        .action-buttons {
          display: flex;
          gap: 15px;
          justify-content: center;
          margin-bottom: 30px;
          flex-wrap: wrap;
        }

        .btn-primary, .btn-secondary {
          padding: 12px 28px;
          text-decoration: none;
          border-radius: 8px;
          font-weight: 600;
          transition: all 0.3s ease;
          display: inline-block;
        }

        .btn-primary {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
        }

        .btn-primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(102, 126, 234, 0.5);
        }

        .btn-secondary {
          background: white;
          color: #764ba2;
          border: 2px solid #764ba2;
        }

        .btn-secondary:hover {
          background: #764ba2;
          color: white;
          transform: translateY(-2px);
        }

        .auto-redirect {
          font-size: 14px;
          color: #999;
          margin-top: 20px;
        }
      `}</style>
    </div>
  );
};

export default NotFound;